import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'
import { BulkTagRequestPayload } from 'types/Participants'

const axiosRequest = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const URL = `site_users/bulk_tag`

const bulkTagEndPoints = {
  addBulkTags: (payload: BulkTagRequestPayload) =>
    axiosRequest().post(URL, payload),
}

const bulkTagsAPI = {
  addBulkTags: (params: BulkTagRequestPayload) =>
    apiWrapper({
      endPoint: bulkTagEndPoints.addBulkTags,
      params,
      errorFailureAction: handleStatus500,
    }),
}

export default bulkTagsAPI
